const chineseNumbers = ['一', '二', '三', '四', '五', '六', '七', '八', '九'];

export default function getChineseNumbers(size) {
  return chineseNumbers.slice(0, size);
}
